__turbopack_context__.v({
  "content": "SidepanelSkeleton-module-scss-module__kM0erq__content",
  "header": "SidepanelSkeleton-module-scss-module__kM0erq__header",
  "indent": "SidepanelSkeleton-module-scss-module__kM0erq__indent",
  "indentItem": "SidepanelSkeleton-module-scss-module__kM0erq__indentItem",
  "section": "SidepanelSkeleton-module-scss-module__kM0erq__section",
});
